import { render, staticRenderFns } from "./ResponsibleSelector.vue?vue&type=template&id=7ffa4c6e&scoped=true"
import script from "./ResponsibleSelector.vue?vue&type=script&lang=js"
export * from "./ResponsibleSelector.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleSelector.vue?vue&type=style&index=0&id=7ffa4c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa4c6e",
  null
  
)

export default component.exports